import React from 'react'
import { AccordionHeader } from '../../../../../Components/Layout/Accordion'
import { getTeamIc } from '../../../../../Utils'

type HeaderParams = {
  teamName?: string
  rosterLength: number
}

export const RegSeasonRosterHeader: React.FC<HeaderParams> = ({
  teamName,
  rosterLength,
}) => {
  return (
    <AccordionHeader
      imgUrl={teamName ? getTeamIc(teamName) : ''}
      label={`SEASON ROSTER`}
      subText={`${rosterLength} Player Roster`}
    />
  )
}
